module.exports = __webpack_public_path__ + "static/media/what-we-do-1.f5cdfa06.png";